angular.module('wbDashboard').controller('PortfolioplusEditControllerAurea',
        ['$scope', '$q', '$uibModal', '$timeout', 'NgTableParams', 'User', 'PlanService', "RiskScore", 'DataService', 'Message',
function ($scope, $q, $uibModal, $timeout, NgTableParams, User, PlanService, RiskScore, DataService, Message) {

    if (!$scope.$stateParams.slug) {
        if ($scope.$stateParams.page === "featured" && $scope.$stateParams.featureSlug) {
        } else if ($scope.$stateParams.page !== "start") {
            $scope.$state.go('.', {page: "start"}, {location: 'replace'});
        }
    }

    $scope.pageData.positionHighlight = {};

    $scope.featuredUntouched = false;
    $scope.featuredName = null;
    $scope.featuredDescription = null;

    $scope.template = null;
    $scope.templateDetails = null;

    $scope.customPortfolio = {
        name: null,
        description: null,
        assetClasses: {},
        milestones: [],
        currentMilestones: [],
        allocationData: {
            stock_percent: 0,
            bond_percent: 0,
            asset_classes: []
        },
        assetFilters: []
    };

    $scope.tabs = {
        active: 'create',
        scrollTop: true,
        data: {
            "featured" : {label: 'Featured', value: 'featured', callbacks: {
                    beforeEnter: function() {
                         if ($scope.$stateParams['#'] === "gotocreate") {
                             $scope.tabs.active = "create";
                         }
                    }
            }},
            "create" : {label: 'Create', value: 'create'}
        }
    };
    $scope.defaultPercent = 1;

    /****************************
     ****** FEATURED PAGE *****
     ****************************/
    $scope.$watch('$stateParams.featureSlug', function(slug) {
        if (slug) {
            $scope.selectFeatured(slug);
        }
    });
    $scope.selectFeatured = function(portfolioSlug) {
        var portfolio;

        PlanService.retrievePortfolios('themed').then(function(portfolios) {
            angular.forEach(portfolios.list, function(p) {
                if (p.slug === portfolioSlug) {
                    portfolio = p;
                }
            });
            if (portfolio) {

                $scope.template = portfolio;

                $scope.templateDetails = new NgTableParams({
                    // initial sort order
                    count: 15,
                    sorting: {}
                }, {
                    counts: [],
                    dataset: portfolio.asset_classes
                });

                angular.forEach(portfolio.asset_classes, function(asset) {
                    asset.percent = asset.target_allocation_rate*100;
                });
                $scope.templateAllocationData = {
                    stock_percent: portfolio.target_stock_rate*100,
                    bond_percent: portfolio.target_bond_rate*100,
                    asset_classes: portfolio.asset_classes,
                    total_value: portfolio.target_stock_rate + portfolio.target_bond_rate
                };
            }
        });
    };
    //add assets from featured portfolio
    $scope.setFeaturedAssets = function(portfolio) {
        var newAssets = {};
        angular.forEach(portfolio.asset_classes, function(asset) {
            newAssets[asset.code] = {
                target_allocation_rate: asset.target_allocation_rate
            };
        });
        angular.forEach($scope.customPortfolio.assetClasses, function(asset) {
            if (asset.code in newAssets) {
                $scope.addAsset(asset.code, newAssets[asset.code].target_allocation_rate * 100);
            } else {
                $scope.removeAsset(asset.code);
            }
        });

        $timeout(function() {
            //want it to run next cycle after the custom asset watcher runs
            $scope.featuredUntouched = true;
        });
        $scope.featuredName = portfolio.name;
        $scope.featuredDescription = portfolio.description;
    };


    /*******************************
     ****** ASSETS SELECT PAGE *****
     *******************************/
    //add initial asset list
    $scope.$watch('assets', function (assets) {
        if (assets) {
            $scope.customPortfolio.assetFilters.length = 0;
            var filters = {};
            angular.forEach(assets, function(asset) {
                $scope.customPortfolio.assetClasses[asset.code] = angular.copy(asset);
                $scope.customPortfolio.assetClasses[asset.code].selected = false;
                $scope.customPortfolio.assetClasses[asset.code].percent = $scope.defaultPercent;

                if (asset.sector) {
                    filters[asset.sector.code] = asset.sector.name;
                }
            });
            angular.forEach(filters, function(name, code) {
                $scope.customPortfolio.assetFilters.push({code:code, name:name});
            });
            $scope.customPortfolio.assetFilters.sort(function(a,b) {
                return a.code > b.code;
            });

            $scope.addExistingAssets();
        }
    });

    $scope.openAssetModal = function(classCode, addButton) {

        var $modalScope = $scope.$new();

        $modalScope.addButton = addButton;
        $modalScope.hasAsset = $scope.hasAsset(classCode);
        $modalScope.asset = DataService.getAssetClass(classCode);


        $modalScope.etfDetails = new NgTableParams({
            // initial sort order
            count: 15,
            sorting: {}
        }, {
            counts: [],
            dataset: $modalScope.asset.assets
        });

        var modalInstance = $uibModal.open({
            templateUrl: "app/themes/aurea/segments/plans/plans/portfolioplus/customportfolio/assets.tpl.html",
            size: 'lg',
            scope: $modalScope,
            windowClass: 'portfolioplus-asset-add-modal'
        });

        modalInstance.result.then(function (asset) {
            //add asset
            if ($scope.hasAsset(classCode)) {
                $scope.removeAsset(classCode);
            } else {
                $scope.addAsset(classCode);
            }
        }).catch(angular.noop).finally(function() {
        });
    };

    $scope.addAsset = function(classCode, percent) {
        if (!percent) percent = $scope.defaultPercent;
        if (classCode in $scope.customPortfolio.assetClasses) {
            percent = Math.round(percent * 10)/10; //fix any js rounding issues
            $scope.customPortfolio.assetClasses[classCode].selected = true;
            $scope.customPortfolio.assetClasses[classCode].percent = percent;
        }
    };
    $scope.removeAsset = function(classCode) {
        if (classCode in $scope.customPortfolio.assetClasses) {
            $scope.customPortfolio.assetClasses[classCode].selected = false;
            $scope.customPortfolio.assetClasses[classCode].percent = $scope.defaultPercent;
        }
    };
    $scope.hasAsset = function(classCode) {
        return $scope.customPortfolio.assetClasses[classCode].selected;
    };

    /****************************
     ****** ALLOCATION PAGE *****
     ****************************/
    $scope.pageData.scroller = {};


    //set data for pie chart when assets change
    $scope.$watch('customPortfolio.assetClasses', function(assets, prev) {
        var selectedAssets = [];
        var bonds = 0, stocks = 0, count = 0, used = 0;

        var highestPercent = 0;
        var imageAsset = null;
        angular.forEach(assets, function(asset) {
            if (!asset.selected) { return; }

            var percent = asset.percent || 0;

            count += 1;

            if (asset.category === "Stocks") {
                stocks += percent;
            }
            if (asset.category === "Bonds") {
                bonds += percent;
            }

            if (percent) {
                used += 1;
            }

            if (percent > highestPercent) {
                imageAsset = asset.code;
                highestPercent = percent;
            }

            if (asset.code in prev) {
                //make prev identical $typeColor to check for otherwise equivalency
                prev[asset.code].$typeColor = asset.$typeColor;
            }

            selectedAssets.push(asset);
        });

        //make sure it wasn't triggered because of the $typeColor key
        if (!angular.equals(assets, prev)) {
            $scope.featuredUntouched = false;
        }

        stocks = Math.round(stocks*10)/10;
        bonds = Math.round(bonds*10)/10;


        $scope.customPortfolio.allocationData.stock_percent = stocks;
        $scope.customPortfolio.allocationData.bond_percent = bonds;
        $scope.customPortfolio.allocationData.asset_classes = selectedAssets;
        $scope.customPortfolio.allocationData.total_value = 1;
        $scope.customPortfolio.percentTotal = Math.round((stocks + bonds)*10)/10;
        $scope.customPortfolio.usedTotal = used;
        $scope.customPortfolio.selectedTotal = count;
        $scope.customPortfolio.imageAsset = imageAsset;

    }, true);
    $scope.fixPercent = function(classCode) {
        var percent = $scope.customPortfolio.assetClasses[classCode].percent;
        //ensure single decimal
        if (percent) {
            percent = Math.floor(percent * 10) / 10;
            $scope.customPortfolio.assetClasses[classCode].percent = percent;
        }
        if (percent !== 0 && !percent) {
            $scope.customPortfolio.assetClasses[classCode].percent = $scope.defaultPercent;
        } else if (percent > 100) {
            $scope.customPortfolio.assetClasses[classCode].percent = 100;
        }
        if ($scope.customPortfolio.selectedTotal === 1) {
            $scope.customPortfolio.assetClasses[classCode].percent = 100;
        }
    };


    /****************************
     ****** MILESTONES PAGE *****
     ****************************/
    $scope.checkExistingMS = function(msId) {
        return $scope.customPortfolio.currentMilestones.indexOf(msId) > -1;
    };
    $scope.checkSelectMS = function(msId) {
        return $scope.customPortfolio.milestones.indexOf(msId) > -1;
    };
    $scope.toggleSelectMS = function(msId) {
        var index = $scope.customPortfolio.milestones.indexOf(msId);
        if (index > -1) {
            $scope.customPortfolio.milestones.splice(index, 1);
        } else {
            $scope.customPortfolio.milestones.push(msId);
        }
    };


    /****************************
     ****** SAVING **************
     ****************************/

    $scope.savePortfolioModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: "modal-portfolioplus-save-confirm.tpl.html",
            size: 'md',
            scope: $scope,
            windowClass: 'portfolioplus-asset-save-modal plan-info-confirm-modal'
        });

        modalInstance.result.then(function () {
            $scope.savePortfolio();
        }).catch(angular.noop).finally(function() {
        });
    };

    $scope.savePortfolio = function() {
        var data, returnedPortfolio;

        data = $scope.formatSubmitData($scope.customPortfolio);

        $scope.pageData.sending = true;
        $q.when(1).then(function() {
            if ($scope.$stateParams.slug) {
                return PlanService.user.updatePortfolio($scope.$stateParams.slug, data);
            } else {
                return PlanService.user.savePortfolio(data);
            }
        }).catch(function(response) {
            var msg = "There was a problem saving" + $scope.customPortfolio.name + " Portfolio";
            if (response.data.error) {
                try {
                    var errors = JSON.parse(response.data.error);
                    if (errors.errors[0].message) {
                        msg = "There was a problem saving: " + errors.errors[0].message;
                    }
                } catch (err) {

                }
            }
            Message.set({
                text: msg,
                type: "danger"
            });
            response.handled = true;
            throw response;
        }).then(function(portfolio) {
            returnedPortfolio = portfolio;
            var milestones = $scope.customPortfolio.milestones.filter(x => !$scope.customPortfolio.currentMilestones.includes(x));
            return $scope.saveMilestones(returnedPortfolio.slug, milestones);
        }).catch(function(response) {
            if (!response.handled) {
                Message.set({
                    text: "Couldn't assign " + $scope.customPortfolio.name + " Portfolio to Milestones",
                    type: "danger"
                });
            }
            throw response;
        }).then(function() {
            PlanService.user.clearPortfolioExtra();
            return PlanService.user.retrievePortfolios(null, true);
        }).then(function() {
            //need to remove all data since positions could have changed
            //must be done after new portfolios retrieved so new portfolio names are available
            return User.retrieveAllMilestones(true, true);
        }).then(function() {
            Message.set({
                text: "Successfully saved " + $scope.customPortfolio.name + " Portfolio",
                type: "success"
            });
            $scope.$state.go('base.plans.custom.portfolioplus');
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    $scope.saveMilestones = function(portfolioSlug, milestones) {
        var msRequests = [];
        angular.forEach(milestones, function(msId) {
            var promise = PlanService.user.setMilestoneAllocation(msId, {allocation_start: portfolioSlug, allocation_end: portfolioSlug});
            msRequests.push(promise);
        });
        return $q.all(msRequests);
    };

    $scope.formatSubmitData = function(portfolio) {
        var data = {
            name: portfolio.name,
            description: portfolio.description,
            asset_classes: []
        };

        angular.forEach(portfolio.assetClasses, function(asset) {
            if (asset.selected === true && asset.percent > 0) {
                data.asset_classes.push({
                    "code": asset.code,
                    "rate": asset.percent/100,
                });
            }
        });

        return data;
    };

    $scope.refreshWaypoint = function() {
        $timeout(function() {
            Waypoint.refreshAll();
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onSuccess({to: "base.plans.custom.portfolioplus.**"}, function (trans) {
        if (!$scope.$stateParams.slug && trans.params().page === "name") {
            if ($scope.featuredUntouched) {
                $scope.customPortfolio.name = $scope.featuredName;
                $scope.customPortfolio.description = $scope.featuredDescription;
                $scope.featuredUntouched = false;
            }
        }
    });
    $scope.$on('$destroy', function () {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

    /*****************************
     ****** UPDATE PORTFOLIO *****
     *****************************/
    if ($scope.$stateParams.slug) {
        $scope.$watch(function() { return PlanService.user.getPortfolios($scope.$stateParams.slug); }, function(portfolio) {
            if (portfolio) {
                $scope.currentPortfolio = portfolio;
                $scope.customPortfolio.name = portfolio.name;
                $scope.customPortfolio.description = portfolio.description;
                $scope.addExistingAssets();
            }
        });
        $scope.$watch(function () { return PlanService.user.getPortfolioPositions($scope.$stateParams.slug); }, function (portfolioPositions) {
            if (portfolioPositions) {
                $scope.customPortfolio.milestones.length = 0;
                angular.forEach(portfolioPositions.milestones, function (ms) {
                    $scope.customPortfolio.milestones.push(ms.milestone_id);
                    $scope.customPortfolio.currentMilestones.push(ms.milestone_id);
                });
            }
        });
    }

    //must be called after both currentPortfolio is loaded and customPortfolio has asset classes added
    $scope.addExistingAssets = function() {
        if ($scope.currentPortfolio && Object.keys($scope.customPortfolio.assetClasses).length) {
            angular.forEach($scope.currentPortfolio.asset_classes, function(asset) {
                $scope.addAsset(asset.code, asset.target_allocation_rate * 100);
            });
        }
    };

}]);
